import { render, staticRenderFns } from "./delivery-modal.vue?vue&type=template&id=474cb4fa&"
import script from "./delivery-modal.vue?vue&type=script&lang=js&"
export * from "./delivery-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports